/* eslint-disable import/prefer-default-export */
import t from './Document.type';

import * as documentService from '../../../services/document.services';
import { toasterMsg } from '../../../Components/Toaster/Toaster';

const errMsg = 'Failed to fetch data';

export const saveManualDocument = (data, translation) => {
  return async () => {
    try {
      const response = await documentService.saveManualDocument(data);
      if (response.code === 200) {
        const msg = translation(`MANUAL_DOCUMENTS.${response.data}`);
        toasterMsg(msg, 'success');
      }
      if (response?.data?.errMsg) {
        const msg = translation(`MANUAL_DOCUMENTS.${response?.data?.errMsg}`);
        toasterMsg(msg?.toString(), 'danger');
      }
      return response;
    } catch (error) {
      toasterMsg(errMsg, 'danger');
    }
    return Promise.resolve();
  };
};

export const getManualDocumentList = (data) => async (dispatch) => {
  try {
    const res = await documentService.getDocumentList(data);
    if (res?.code === 200 && res?.data) {
      await dispatch({
        type: t.FETCH_DOCUMENT_LIST,
        payload: res?.data,
      });
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return Promise.resolve();
};

export const clearReducer = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR_DOCUMENT_REDUCER,
    });
    return true;
  } catch (error) {
    toasterMsg(error, 'danger');
  }
  return Promise.resolve();
};

export const MultiDeleteManualDocuemnt = (payload, transactionMsg) => async () => {
  try {
    const res = await documentService.MultiDeleteManualDocument(payload);
    if (res?.code === 200 && res.data) {
      const msg = transactionMsg(`MANUAL_DOCUMENTS.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err, 'danger');
  }
  return Promise.resolve();
};

export const getBreadCrumbDocumentData = (data) => async (dispatch) => {
  try {
    const res = await documentService.getBreadCrumbData(data);
    if (res?.code === 200 && res?.data) {
      await dispatch({
        type: t.FETCH_BREAD_CRUMB_DATA,
        payload: res?.data,
      });
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return Promise.resolve();
};

export const archiveUnarchiveDocument = (params, transactionMsg) => async () => {
  try {
    const res = await documentService.archiveUnarchiveDocument(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`MANUAL_DOCUMENTS.${res.data}`);
      toasterMsg(msg, 'success');
    }
    if (res?.data?.errMsg) {
      const msg = res?.data?.errMsg;
      toasterMsg(msg?.toString(), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err, 'danger');
  }
  return Promise.resolve();
};

export const getDocumentDataById = (data) => async (dispatch) => {
  try {
    const res = await documentService.getDocumentDataById(data);
    if (res?.code === 200 && res?.data) {
      await dispatch({
        type: t.GET_DOCUEMNT_BY_ID,
        payload: res?.data,
      });
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return Promise.resolve();
};

export const renewManualDocument = (data, translation) => {
  return async () => {
    try {
      const response = await documentService.renewManualDocument(data);
      if (response.code === 200) {
        const msg = translation(`MANUAL_DOCUMENTS.${response.message}`);
        toasterMsg(msg, 'success');
      }
      if (response?.data?.errMsg) {
        const msg = translation(`MANUAL_DOCUMENTS.${response?.data?.errMsg}`);
        toasterMsg(msg?.toString(), 'danger');
      }
      return response;
    } catch (error) {
      toasterMsg(error, 'danger');
    }
    return Promise.resolve();
  };
};

export const getAllFolderList = (data) => async (dispatch) => {
  try {
    const res = await documentService.getAllFolderList(data);
    if (res?.code === 200 && res?.data) {
      await dispatch({
        type: t.GET_FOLDER_LIST,
        payload: res?.data,
      });
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return Promise.resolve();
};

export const moveDocumentToFolder = (data, translation) => {
  return async () => {
    try {
      const response = await documentService.moveDocumentToFolder(data);
      if (response.code === 200) {
        const msg = translation(`MANUAL_DOCUMENTS.${response.message}`);
        toasterMsg(msg, 'success');
      }
      if (response?.data?.errMsg) {
        const msg = translation(`MANUAL_DOCUMENTS.${response?.data?.errMsg}`);
        toasterMsg(msg?.toString(), 'danger');
      }
      return response;
    } catch (error) {
      toasterMsg(error, 'danger');
    }
    return Promise.resolve();
  };
};

export const shareDocumentWithSupplier = (id, data, translation) => async () => {
  try {
    const res = await documentService.shareDocumentWithSupplier(id, data);
    if (res.code === 200) {
      const msg = translation(`MANUAL_DOCUMENTS.${res.message}`);
      toasterMsg(msg, 'success');
    }
    if (res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
  return Promise.resolve();
};

export const updateManualDocument = (data, translation) => {
  return async () => {
    try {
      const response = await documentService.updateManualDocument(data);
      if (response.code === 200) {
        const msg = translation(`MANUAL_DOCUMENTS.${response.data}`);
        toasterMsg(msg, 'success');
      }
      if (response?.data?.errMsg) {
        const msg = translation(`MANUAL_DOCUMENTS.${response?.data?.errMsg}`);
        toasterMsg(msg?.toString(), 'danger');
      }
      return response;
    } catch (error) {
      toasterMsg(errMsg, 'danger');
    }
    return Promise.resolve();
  };
};
export const downloadFolder = (data) => {
  return async () => {
    try {
      return await documentService.downloadFolder(data);
    } catch (error) {
      toasterMsg(errMsg, 'danger');
    }
    return Promise.resolve();
  };
};
